import clsx from "clsx";

import { ConfirmDialogProvider } from "@/features/common/contexts/useConfirmDialogContext";
import { useBreakpoints } from "@/features/common/hooks/useBreakpoint";
import { DeletePhotoButton } from "@/features/modelPhoto/components/DeletePhotoButton";
import { ReturnModeButton } from "@/features/modelPhoto/components/ReturnModeButton";
import { UploadPhotoButton } from "@/features/modelPhoto/components/UploadPhotoButton";
import { AccessTypeEnum } from "@/generated/graphql-hooks";

export const EditPhotoButtonGroup = ({
  accessType = AccessTypeEnum.Public,
}: {
  accessType?: AccessTypeEnum;
}) => {
  const { currentBreakpoint } = useBreakpoints();

  return (
    <div
      className={clsx(
        currentBreakpoint === "sm" ? "space-x-8" : "space-x-10",
        "fixed left-1/2 bottom-10 z-40 flex w-max -translate-x-1/2 rounded-lg bg-white px-6 py-4 shadow",
      )}
    >
      <ConfirmDialogProvider>
        <DeletePhotoButton accessType={accessType} />
      </ConfirmDialogProvider>

      <UploadPhotoButton accessType={accessType} />

      <ReturnModeButton />
    </div>
  );
};
